import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { adminPanelConfigOptionType, adminPanelOptionConfigRegistryType } from '../../components/adminPanelLayout/adminPanelTypes';
import { ChannelkartNetworkGet } from '../../services/networkService';
import RenderSvg from '../../components/renderSvg/RenderSvg';
import './GenericPanel.css';
import { Loader } from '../../components/loader/Loader';
import { getMetaDataConfig } from '../../services/uiConfigService';

interface GenericPanelProps {
    configName: string,
    headerName: string,
    defaultRoute: string,
}
async function getGenericPanelOptionsConfig(configName: string){
    const currentUserData = JSON.parse(localStorage.getItem("authContext") ?? "{}")?.user;
    const clientConfig = await getMetaDataConfig("clientconfig");
    const designations = currentUserData.designation ?? [];
    if(designations.includes("admin")){
        const config = clientConfig.find((config: { domainType: string }) => config.domainType === configName)?.domainValues;
        return config?.[0]?.value ?? [];

    }else if(designations.length!==0){
        const role = designations[0];
        const roleConfigName = `${designations}_${configName}`;
        const roleConfig = clientConfig.find((config: { domainType: string }) => config.domainType === roleConfigName)?.domainValues;
        if(roleConfig){
            return roleConfig?.[0]?.value ?? [] 
        }else{
            const config = clientConfig.find((config: { domainType: string }) => config.domainType === configName)?.domainValues;
            return config?.[0]?.value ?? [];
        }
    }
    
    
}
const genericPanelOptionConfigRegistry: adminPanelOptionConfigRegistryType = {
    manageBanner: {
        label: "Manage Banner",
        description: "Create, Update Delete and manage banner",
        svgName: "Variable",
        route: "/manageBanner",
        color: "#0ABBD5"
    },
    manageBasket: {
        label: "Manage Basket",
        description: "Create, Update Delete and manage basket",
        svgName: "OutletDetails",
        route: "/manageBasket",
        color: "#0ABBD5"
    },
    manageBucket: {
        label: "Manage Bucket",
        description: "Create, Update Delete and manage the bucket",
        svgName: "User",
        route: "/manageBucket",
        color: "#fad11d"
    },
    homepageConfig: {
        label: "Homepage Config",
        description: "Manage the visibility and positioning of banner, bucket and basket on homepage",
        svgName: "PJPVisitPlan",
        route: "/homepageConfig",
        color: "#df263d"
    },
    appConfig: {
        label: "App Config",
        description: "",
        svgName: "PJPVisitPlan",
        route: "/appConfig",
        color: "#df263d"
    },
    loginConfig: {
        label: "Login Config",
        description: "",
        svgName: "PJPVisitPlan",
        route: "/loginConfig",
        color: "#df263d"
    },
    themeConfig: {
        label: "Theme Config",
        description: "",
        svgName: "PJPVisitPlan",
        route: "/themeConfig",
        color: "#df263d"
    },
    analyticsDashboard: {
        label: "Analytics Dashboard",
        description: "",
        svgName: "Variable",
        route: "/analyticsDashboard",
        color: "#0ABBD5"
    },
    slowQueries: {
        label: "Slow Queries",
        description: "",
        svgName: "User",
        route: "/slowQueries",
        color: "#fad11d"
    },
    validations: {
        label: "Validations",
        description: "",
        svgName: "PJPVisitPlan",
        route: "/validations/division",
        color: "#df263d"
    },
    integrationStatistics: {
        label: "Integration Statistics",
        description: "",
        svgName: "OutletDetails",
        route: "/integrationStatistics",
        color: "#52b894"
    },
    integrationJob:{
        label: "Integration Job",
        description: "",
        svgName: "User",
        route: "/integrationJob",
        color: "#fad11d"
    },
        integrationPlatform:{
        label: "Integration Platform",
        description: "",
        svgName: "PJPVisitPlan",
        route: "/integrationPlatform",
        color: "#df263d"
    },
    complianceDashboard: {
        label: "Order complaince dashboard",
        description: "",
        svgName: "Variable",
        route: "/complianceDashboard",
        color: "#0ABBD5"
    },
    edaQuantityCompliance: {
        label: "EDA Quantity Compliance",
        description: "",
        svgName: "OutletDetails",
        route: "/edaQuantityCompliance",
        color: "#0ABBD5"
    },
    skuSelectionCompliance: {
        label: "EDA sku selection complaince",
        description: "",
        svgName: "User",
        route: "/skuSelectionCompliance",
        color: "#fad11d"
    },
    createNewCoupon: {
		label: "Create New Coupon",
		description: "Create coupon as per your preference",
		svgName: "OutletDetails",
		route: "couponData",
		color: "#52b894"
	},
	createConsumption: {
		label: "Create Consumption",
		description: " 'X' consumed",
		svgName: "User",
		route: "",
		color: "#fad11d"
	},
	pendingForApproval: {
		label: "Pending For Approval",
		description: "Approval of the coupons created",
		svgName: "PJPVisitPlan",
		route: "",
		color: "#52b894"
	}, 
    liveCouponDashboard:{
		label: "Coupon Repository",
		description: "View the list of published coupon",
		svgName: "OutletDetails",
		route: "livecouponData",
		color: "#52b894"
	},
    manageHomeScreen: {
        label: "Manage Homescreen",
        description: "Create, Update Delete and manage the blocks",
        svgName: "OutletDetails",
        route: "/manageHomeScreen",
        color: "#52b894"
    },
    manageDisplayCapture: {
        label: "Manage Display Capture",
        description: "Manage Display Capture",
        svgName: "manageUpdateAccessIcon",
        route: "/manageDisplayCapture",
        color: "#df263d"
    }
}

function GenericPanel(props: GenericPanelProps) {
  const [genericPanelOptions,setGenericPanelOptions] = useState<adminPanelConfigOptionType[]>([]);
  const [showLoader,setShowLoader] = useState<boolean>(false);
  useEffect(() => {
    async function mergeAndSetGenericPanelOptions(){
        setShowLoader(true);
        let genericPanelOptionsConfig = await getGenericPanelOptionsConfig(props.configName);
        const mergedGenericPanelOptions = genericPanelOptionsConfig.map((option: {id: string} ) => {
            const id = option.id;
            const optionRegistyConfigs = genericPanelOptionConfigRegistry[id] || {}
            return {
                ...optionRegistyConfigs,
                ...option
            }
        })
        setGenericPanelOptions(mergedGenericPanelOptions);
        setShowLoader(false);
       
    }
    mergeAndSetGenericPanelOptions()
  },[])
  const navigate = useNavigate();
  return (
    <div className='genericPanelOptionsContainer'>
        <div className='genericPanelHeader'>
            <Typography className='genericPanelOptionsHeading' variant='h4'>{props.headerName}</Typography>
            <button className="generic-back-button" onClick={() => {window.history.back();}} style={{marginLeft:"10px"}}>BACK</button>
        </div>
        <div className='genericPanelCardsContainer'>
            {showLoader? <Loader /> : genericPanelOptions.map((option: adminPanelConfigOptionType,index: number) => {
                return <div key={index} className='genericPanelOptionCard' onClick={() => navigate(option.route || props.defaultRoute)  }>
                    <div className='genericPanelOptionCardHeader'>
                        <Typography className='designerPanelCardHeading' variant='h5'>{option.label}</Typography>
                        <div className='genericPanelOptionCardIconContainer' style={{ backgroundColor: option.color}}>
                            <div className='genericPanelOptionCardIcon'>
                                <RenderSvg name={option.svgName} />
                            </div>
                        </div>
                    </div>
                    <Typography className="genericPanelCardDescription" variant='subtitle2'>{option.description}</Typography>
                </div>})}
        </div>
    </div>
  )
}

export default GenericPanel;